import { useEffect, useState } from 'react';
import { api, type MeetingRecord } from '../api.js';
import type { Lang } from '@calendar/shared';

export function MeetingRecords({eventId,lang}: {eventId:string;lang:Lang}) {
  const fa=lang==='fa';
  const [items,setItems]=useState<MeetingRecord[]>([]);
  const [kind,setKind]=useState('result');
  const [body,setBody]=useState('');
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [loaded,setLoaded]=useState(false);
  const labels: Record<string,string> = fa ? {result:'نتیجه',resolution:'مصوبه',report:'گزارش'} : {result:'Result',resolution:'Resolution',report:'Report'};
  useEffect(() => { let active=true; setLoaded(false); api.records(eventId).then(r=>{if(active){setItems(r.items);setLoaded(true);}}).catch(()=>{if(active)setError(fa?'گزارش‌ها دریافت نشدند.':'Could not load records.');});return()=>{active=false;}; },[eventId,fa]);
  async function save() {
    setBusy(true);setError('');
    try { const r=await api.addRecord(eventId,kind,body);setItems(r.items);setBody('');setLoaded(true); }
    catch {setError(fa?'ثبت انجام نشد؛ متن شما حفظ شده است.':'Save failed; your text is preserved.');}
    finally {setBusy(false);}
  }
  return <section className="meeting-records glass"><h3>{fa?'صورت‌جلسه و گزارش‌ها':'Meeting records'}</h3>
    <p className="muted">{fa?'برای جلسات گذشته و فعلی؛ هر ثبت به تاریخچه اضافه می‌شود. تصویر را از بخش پیوست همین جلسه اضافه کنید.':'For current and past meetings. Each record is kept in the history. Add photos using this meeting’s attachments.'}</p>
    <label>{fa?'نوع ثبت':'Type'}<select className="select" value={kind} onChange={e=>setKind(e.target.value)}>{Object.entries(labels).map(([k,v])=><option key={k} value={k}>{v}</option>)}</select></label>
    <textarea className="textarea" aria-label={fa?'متن صورت‌جلسه':'Record text'} maxLength={20000} value={body} onChange={e=>setBody(e.target.value)} />
    <button type="button" className="btn btn--primary" disabled={busy||!body.trim()} onClick={()=>void save()}>{busy?'…':fa?'ثبت در تاریخچه جلسه':'Add record'}</button>
    {error&&<p role="alert">{error}</p>}
    {loaded && !items.length && <p className="muted">{fa?'هنوز گزارشی ثبت نشده است.':'No records yet.'}</p>}
    {items.map(item=><article className="meeting-record" key={item.id}><strong>{labels[item.kind]}</strong><time>{new Date(item.createdAt).toLocaleString(fa?'fa-IR':'en-GB')}</time><p>{item.body}</p></article>)}
  </section>;
}
